import { BusinessFunctionsSelectionBase } from '../../../../components/business-functions';
import { GET_BUSINESS_FUNCTIONS } from '../../../dataInputs/data-inputs/business-functions/queries';
import {
  GET_BUSINESS_FUNCTIONS_BY_LOCATION,
  UPDATE_SELECTED_LOCATION_BUSINESS_FUNCTIONS,
} from '../queries';
import { useParams } from 'react-router';
import { SetSelectedLocationBusinessFunctionsInput } from '../types';
import { useLocationName } from '../../../../hooks/useLocationName';
import { BusinessFunctionTaggingTitle } from '../../constants';

export const LocationBusinessFunctionsSelection = () => {
  const { locationId } = useParams();
  const { locationName } = useLocationName(locationId);

  return (
    <BusinessFunctionsSelectionBase
      title={`Location ${BusinessFunctionTaggingTitle}`}
      subtitle={`${locationName} Business Function Selection`}
      brief={`Select which business functions you'd like to tag applications to at the ${locationName} location. If a business function is missing, you can add it by clicking the "Add Function" button.`}
      backPath={`/cyber/location-level/${locationId}/business-functions`}
      fetchAllQuery={{
        query: GET_BUSINESS_FUNCTIONS,
        identifier: 'getBusinessFunctions',
        variables: {
          filter: {
            selected: false,
          },
        },
      }}
      fetchSelectedQuery={{
        query: GET_BUSINESS_FUNCTIONS_BY_LOCATION,
        identifier: 'getBusinessFunctionsByLocation',
        variables: {
          data: locationId,
          filter: {
            selected: true,
          },
        },
      }}
      updateMutation={{
        mutation: UPDATE_SELECTED_LOCATION_BUSINESS_FUNCTIONS,
        variableName: 'data.businessFunctionUUIDs',
        variableStructure: {
          data: {
            locationUUID: locationId,
          } as SetSelectedLocationBusinessFunctionsInput,
        },
        formatFunction: (itemUuid: string) => itemUuid,
      }}
      refetchQueries={[
        {
          query: GET_BUSINESS_FUNCTIONS,
          variables: {
            filter: {
              selected: false,
            },
          },
        },
        {
          query: GET_BUSINESS_FUNCTIONS_BY_LOCATION,
          variables: {
            data: locationId,
            filter: {
              selected: false,
            },
          },
        },
      ]}
    />
  );
};
